import { TChangeStepHandlerResult } from '../models'

export const canNotProceed = (result: TChangeStepHandlerResult) =>
  result && (result.hasError || !result.changeStep)
